import AgendamentoInterceptor from '@finx/web-repository/src/apis/Agendamento/AgendamentoInterceptor'
import FactoryResponse from '@/factories/FactoryResponse'
import { Procedimento, OPME, Equipamento, Hemocomponente, TipoDocumentoUpload, AlteracaoDataAgendamento, AlteracaoDataMensagem, SolicitacaoQueryString, NovoFornecedor, StatusOption } from '@/types/_'
// eslint-disable-next-line import/no-cycle
import { timeout, toHttpParams } from '@/utils/common'
import { IProtocoloJustificativaDoMedico } from '@/types/interfaces/protocolo/protocolo-justificativa-do-medico.interface'
import { ConfirmacaoCirurgicaStatusEnum, MotivoRecusaDoOrcamento } from '@/types/interfaces/Solicitacao'
import { SearchSchedulingPayloadProps } from '@/types/interfaces/SolicitacaoCirurgia'


const factory = new FactoryResponse()
const api = new AgendamentoInterceptor()

export default {
  async post(medicoSolicitanteId: any, agendamentoCirurgia) {
    const request = await api.post(`/medico-solicitante/${medicoSolicitanteId}/solicitar-agendamento`, agendamentoCirurgia)
    return factory.build(request)
  },

  async postAlteracaoDataAgendamento(solicitacaoId: string, alteracaoDataAgendamento: AlteracaoDataAgendamento) {
    const request = await api.post(`/solicitacoes/${solicitacaoId}/data-agendamento/alterar`, alteracaoDataAgendamento)
    return factory.build(request)
  },

  async postDataAgendamentoMensagem(solicitacaoId: string, mensagem: AlteracaoDataMensagem) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/data-agendamento/chat`, mensagem)
    return factory.build(request)
  },

  async finalizar(solicitacaoId: string, payload?: any) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/finaliza-agendamento`, { ...payload })
    return factory.build(request)
  },

  async getAgendamentoCirurgiaById(solicitacaoId: string) {
    const request = await api.get(`solicitacao/${solicitacaoId}`)
    return factory.build(request)
  },

  async cancelarSolicitacao(solicitacaoId: string) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/medico/solicita-cancelamento?motivo=PedidoDoCirurgiao`, '')
    return factory.build(request)
  },

  async autorizacaoParcial(solicitacaoId: string) {
    const request = await api.put(`solicitacoes/${solicitacaoId}/medico/autoriza-autorizacao-parcial`, '')
    return factory.build(request)
  },

  async put(solicitacaoId: string, agendamentoCirurgia: any) {
    const request = await api.put(`/solicitacoes/${solicitacaoId}/update-agendamento`, agendamentoCirurgia)
    return factory.build(request)
  },

  async createOrcamentoAvulso(agendamentoCirurgia: any) {
    const request = await api.post('/medico-solicitante/solicitar-orcamento-particular-avulso', agendamentoCirurgia)
    return factory.build(request)
  },

  async get(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}`)
    return factory.build(request)
  },

  async rejectFidelizationProtocolSuggestion(surgerySolicitationId: string, payload: IProtocoloJustificativaDoMedico) {
    const APIRequest = await api.put(`/medico-recusa-justificativa-fidelizacao-backoffice/${surgerySolicitationId}`, payload)
    return factory.build(APIRequest)
  },

  async updateExecutantDoctor(executantDoctorId: string, surgerySolicitationId: string, payload) {
    const APIRequest = await api.put(`/solicitacoes/${surgerySolicitationId}/medico/${executantDoctorId}/executor`, payload)
    return factory.build(APIRequest)
  },

  async getHospitalById(hospitalId: string) {
    const request = await api.get(`/hospitais/${hospitalId}`)
    return factory.build(request)
  },

  async getDataAgendamentoChat(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/data-agendamento/chat`)
    return factory.build(request)
  },

  async medicoRespondeOrcamentoDeCirurgiaParticular(params: any) {
    const request = await api.put('solicitacoes/medicoRespondeOrcamentoDeCirurgiaParticular', params)
    return factory.build(request)
  },

  async getAll(query: SolicitacaoQueryString) {
    const queryParams = toHttpParams(query)
    const request = await api.get(`/solicitacoes-medico?${queryParams}`)
    return factory.build(request)
  },

  async getHospitais(medicoSolicitanteId: any) {
    const request = await api.get(`medico-solicitante/${medicoSolicitanteId}/hospitais`)
    return factory.build(request)
  },

  async getAllHospital() {
    const request = await api.get('suporte/hospitais')
    return factory.build(request)
  },

  async getHospitaisByUserCurrent() {
    const request = await api.get('usuario-hospital/current/hospitais')
    return factory.build(request)
  },

  uploadLaudo(formData: any, headers: any, solicitacaoId: string) {
    return api.upload(`/laudos/${solicitacaoId}/upload`, formData, headers)
  },

  upload(formData: any, tipoDocumento: TipoDocumentoUpload, headers: any, solicitacaoId: string) {
    return api.upload(`/solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`, formData, headers)
  },

  async getCidSearch(hospitalId: String, medicoSolicitanteId: String, searchText: String) {
    const request = await api.get(`/hospitais/${hospitalId}/medico-solicitante/${medicoSolicitanteId}/cids?searchtext=${searchText}`)
    return factory.build(request)
  },

  async getAllCidBySolicitacaoId(id: String) {
    const request = await api.get(`solicitacoes/${id}/cids`)
    return factory.build(request)
  },

  async getAllConvenio(hospitalId: String) {
    const request = await api.get(`/hospitais/${hospitalId}/convenios`)
    return factory.build(request)
  },

  // Fornecedores para suporte...
  async getAllFornecedores(params: any) {
    const { pagina } = params
    const { qtdPorPagina } = params
    const { searchText } = params
    const { hospitalId } = params
    let query = ''

    if (pagina) query += `&pagina=${pagina || 1}`
    if (qtdPorPagina) query += `&qtdPorPagina=${qtdPorPagina || 25}`
    if (searchText) query += `&searchText=${searchText || ''}`

    query = query.length > 0 ? `?${query.substr(1, query.length - 1)}` : ''

    const request = await api.get(`/suporte/hospital/${hospitalId}/fornecedores${query}`)
    return factory.build(request)
  },

  async upsertFornecedor(params: any) {
    const request = await api.put(`/suporte/hospital/${params.hospitalId}/fornecedores`, params)
    return factory.build(request)
  },

  async getConvenioById(params: any) {
    const request = await api.get(`/hospitais/${params.hospitalId}/convenio/${params.convenioId}`)
    return factory.build(request)
  },

  async getAllPlanos(hospitalId: String, convenioId: String) {
    const request = await api.get(`/hospitais/${hospitalId}/convenios/${convenioId}/planos`)
    return factory.build(request)
  },

  async getAllInstrumentos(procedimentoIds: string[], hospitalId: String) {
    let params: string = ''
    procedimentoIds.map((c) => {
      if (c) {
        params += `&procedimentoIdList=${c}`
      }
      return c
    })

    params = params.substring(1, params.length)
    const request = await api.get(`/solicitacoes/instrumentos?${params}&hospitalid=${hospitalId}`)
    return factory.build(request)
  },

  async getOrcamentosBySolicitacaoId(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/orcamentos`)
    return factory.build(request)
  },

  async getAllLaudos(solicitacaoId: String, tipoDocumento: TipoDocumentoUpload) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`)
    return factory.build(request)
  },

  async getAllFile(solicitacaoId: string, tipoDocumento: TipoDocumentoUpload) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/documentos/${tipoDocumento}`)
    return factory.build(request)
  },

  async getAllReservaHemocomponentes(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/reservaHemocomponentes`)
    return factory.build(request)
  },

  async deleteLaudoById(hospitalId: string, id: string) {
    const request = await api.delete(`/hospitais/${hospitalId}/laudos/${id}/delete`)
    return factory.build(request)
  },

  async deleteReservaHemocomponente(solicitacaoId: string, tipo: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/reservaHemocomponentes/${tipo}`)
    return factory.build(request)
  },

  async postReservaHemocomponente(solicitacaoId: string, hemocomponente: Hemocomponente) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/reservaHemocomponentes`, hemocomponente)
    return factory.build(request)
  },

  async postPaciente(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/pacientes`, params)
    return factory.build(request)
  },

  async postCid(solicitacaoId: string, cid) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/cids`, cid)
    return factory.build(request)
  },

  async deleteCid(solicitacaoId: string, cidId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/cids/${cidId}`)
    return factory.build(request)
  },

  async getAllFornecedor(hospitalId: String, convenioId: String, medicoId: string, solicitacaoId: string) {
    const request = await api.get(`fornecedores?HospitalId=${hospitalId}&convenioId=${convenioId}&medicoId=${medicoId}&solicitacaoId=${solicitacaoId}`)
    return factory.build(request)
  },

  async getTemplateHospital(hospitalId: String) {
    const request = await api.get(`solicitacoes/${hospitalId}/template`)
    return factory.build(request)
  },

  async getTemplateBackofficeHospital(hospitalId: String) {
    const request = await api.get(`hospitais/${hospitalId}/template-backoffice`)
    return factory.build(request)
  },

  async postForncecedor(fornecedor: any) {
    const request = await api.post('agendamento/fornecedor', fornecedor)
    return factory.build(request)
  },

  async getOpmeSearch(
    medicoSolicitanteId: String,
    searchText: String,
    procedimentos: string[],
    convenioId: String | null,
    hospitalId: String,
  ) {
    let parameters = procedimentos.reduce((target, source) => {
      if (!source) return ''
      let t = target
      t += `&procedimentos=${source}`
      return t
    }, '')

    if (searchText) {
      parameters += `&searchText=${searchText}`
    }

    if (convenioId) {
      parameters += `&convenioId=${convenioId}`
    }
    if (hospitalId) {
      parameters += `&hospitalId=${hospitalId}`
    }

    if (parameters) {
      parameters = `?${parameters.substring(1, parameters.length)}`
    } else {
      parameters = ''
    }

    const request = await api.get(`medico-solicitante/${medicoSolicitanteId}/opmes${parameters}`)
    return factory.build(request)
  },

  async postProcedimento(solicitacaoId: string, procedimento: Procedimento) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/procedimentos`, procedimento)
    return factory.build(request)
  },

  async updateProcedimentoBySolicitacaoId(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/procedimentos/${params.procedimentoId}`, params)
    return factory.build(request)
  },

  async postOpme(solicitacaoId: string, opme: OPME) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/opmes`, opme)
    return factory.build(request)
  },

  async postEquipamento(solicitacaoId: string, data: { grupoEquipamentoId: string, equipamentoId?: string }) {
    const request = await api.post(`solicitacoes/${solicitacaoId}/equipamentos`, data)
    return factory.build(request)
  },

  async deleteOpme(solicitacaoId: string, opmeId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/opmes/${opmeId}`)
    return factory.build(request)
  },

  async deleteProcedimento(solicitacaoId: string, procedimentoId: string) {
    const request = await api.delete(`procedimento/${solicitacaoId}/${procedimentoId}/solicitacao-procedimento`)
    return factory.build(request)
  },

  async deleteProcedimentoPrincipal(solicitacaoId: string) {
    const request = await api.delete(`procedimento/${solicitacaoId}/solicitacao-procedimento-principal`)
    return factory.build(request)
  },

  async getProcedimentoSearch(medicoSolicitanteId: String, hospitalId: String, convenioId: string, searchText: String) {
    const request = await api.get(`medicos/${medicoSolicitanteId}/hospitais/${hospitalId}/procedimentos?convenioId=${convenioId}&searchText=${searchText}`)
    return factory.build(request)
  },

  async getProcedimentoSemConvenio(medicoSolicitanteId: String, searchText: String) {
    const request = await api.get(`medico-solicitante/${medicoSolicitanteId}/procedimentos?searchtext=${searchText}`)
    return factory.build(request)
  },

  async getSolicitacaoProcedimentos(solicitacaoId: String) {
    const request = await api.get(`/solicitacoes/${solicitacaoId}/procedimentos`)
    return factory.build(request)
  },

  async getOpmes(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/opmes`)
    return factory.build(request)
  },

  async getEquipamentos(solicitacaoId: String) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/equipamentos`)
    return factory.build(request)
  },

  async getEquipamentoSearch(hospitalId: String, searchText: String) {
    const request = await api.get(`hospitais/${hospitalId}/equipamentos?searchText=${searchText}`)
    return factory.build(request)
  },

  async getEquipamentoGrupoSearch(hospitalId: String, searchText: String) {
    const request = await api.get(`hospitais/${hospitalId}/grupoequipamento?searchText=${searchText}`)
    return factory.build(request)
  },

  async getAllGrupoEquipamentoParaOMedico(hospitalId: String, searchText: String) {
    const request = await api.get(`hospitais/${hospitalId}/grupoequipamento/medico?searchText=${searchText}`)
    return factory.build(request)
  },

  async deleteGrupoEquipamento(solicitacaoId: string, equipamentoId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/grupoequipamento/${equipamentoId}`)
    return factory.build(request)
  },

  async getAllMedicoByInstrumentadorId() {
    const request = await api.get('secretarias/medicos')
    return factory.build(request)
  },

  async getMedicoshospitalByUserCurrent() {
    const request = await api.get('usuarios/hospitais/medicos')
    return factory.build(request)
  },

  async associarMedicoLocaisAtendimento(params: any) {
    const request = await api.post(`medico/${params.medicoId}/associar-local-atendimento-ambulatorio`, params)
    return factory.build(request)
  },

  async getLocaisAtendimentoHospitalByMedicoId(params: any) {
    const request = await api.get(`usuarios/hospitais/medicos/locais-atendimento-ambulatorio?medicoid=${params.medicoId}`)
    return factory.build(request)
  },

  async salvarNovoFornecedor(novoFornecedor: NovoFornecedor) {
    const request = await api.post('agendamento/fornecedor', novoFornecedor)
    return factory.build(request)
  },

  async cirurgiaRealizada(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/atualiza-status-cirurgia/${params.statusCirurgia}`, {})
    return factory.build(request)
  },

  async removeMedicoLocalAtendimento(params: any) {
    const request = await api.delete(`agendamento/medico/${params.medicoId}/local-atendimento/${params.localAtendimentoId}`)
    return factory.build(request)
  },

  async medicoRecebeNotificacaoEmailPessoal(params: any) {
    const request = await api.put(`agendamento/medico/${params.medicoId}/recebe-email-notificacao/${params.recebeEmail}`, params)
    return factory.build(request)
  },

  async adicionaMedicoLocalAtendimento(params: any) {
    const request = await api.post(`agendamento/medico/${params.medicoId}/local-atendimento`, params)
    return factory.build(request)
  },

  async backofficeOrcamentoEnviaOrcamento(params: any) {
    const request = await api.put(`solicitacoes-backoffice/${params.solicitacaoId}/orcamento/${params.acaoOrcamento}`, params)
    return factory.build(request)
  },

  async getAllLocalAtendimentoByMedico(medicoId: string, hospitalId: string) {
    const request = await api.get(`medico/${medicoId}/hospital/${hospitalId}/local-atendimento`)
    return factory.build(request)
  },

  async getAllLocalAtendimentoByMedicoId(medicoId: string) {
    const request = await api.get(`medicos/${medicoId}/local-atendimento`)
    return factory.build(request)
  },

  async updateLocalAtendimento(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/local-atendimento/${params.localAtendimentoId}`, params)
    return factory.build(request)
  },

  async getModeloCirurgia(hospitalId: string, medicoId: string, convenioId?: string, planoId?: string, localAtendimentoId?: string) {
    const queryParams = toHttpParams({ convenioId, planoId: planoId || undefined, localAtendimentoId: localAtendimentoId || undefined })

    const request = await api.get(`hospitais/${hospitalId}/medicos/${medicoId}/modelo-cirurgia?${queryParams}`)
    return factory.build(request)
  },

  async criarModeloCirurgia(params: any) {
    const request = await api.post('modelo-cirurgia', params)
    return factory.build(request)
  },

  async aplicarCirurgiaModelo(params: any) {
    const request = await api.post(`solicitacoes/${params.solicitacaoId}/aplicar-modelo?modeloId=${params.modeloCirurgiaId}`, params)
    return factory.build(request)
  },

  async updateModeloFormulario(params: any) {
    const request = await api.put('hospital/configuracao-formulario', params)
    return factory.build(request)
  },

  async getPacienteByHospital(hospitalId: string, queryParams: any) {
    const validQueryKeys = ['cpf', 'rgh', 'nome', 'carteirinha', 'dataNascimento', 'convenioId']

    const buildQueryString = (params: any, validKeys: string[]): string => validKeys
      .filter(key => key in params && params[key] !== undefined && params[key] !== null)
      .map(key => `${key}=${encodeURIComponent(params[key])}`)
      .join('&')

    const queryString = buildQueryString(queryParams, validQueryKeys)

    const request = await api.get(`hospitais/${hospitalId}/pacientes?${queryString}`)

    return factory.build(request)
  },

  async criaPaciente(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/pacientes`, params)
    return factory.build(request)
  },

  async getGrupoOpmeByMedico(hospitalId: string, medicoId: string, solicitacaoId: string, params: string[]) {
    let query: string = `?solicitacaoId=${solicitacaoId}`

    if (params && params.length > 0) {
      params.forEach((p: string) => {
        query += `&procedimentosCodigo=${p}`
      })
    }

    const request = await api.get(`hospitais/${hospitalId}/medicos/${medicoId}/grupos-opme${query}`)
    return factory.build(request)
  },

  async getMedicoOpme(hospitalId: string, medicoId: string, solicitacaoId: string) {
    const request = await api.get(`hospitais/${hospitalId}/medicos/${medicoId}/opmes?solicitacaoId=${solicitacaoId}`)
    return factory.build(request)
  },

  async getGrupoOpmeDaSolicitacao(solicitacaoId: string) {
    const request = await api.get(`solicitacoes/${solicitacaoId}/grupos-opme`)
    return factory.build(request)
  },

  async createMedicoOpme(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/medicos/${params.medicoId}/opmes`, params)
    return factory.build(request)
  },

  async createMedicoGrupoOpme(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/medicos/${params.medicoId}/grupos-opme`, params)
    return factory.build(request)
  },

  async deleteMedicoGrupoOpme(hospitalId: string, medicoId: string, grupoOpmeId: string) {
    const request = await api.delete(`hospitais/${hospitalId}/medicos/${medicoId}/grupos-opme/${grupoOpmeId}`)
    return factory.build(request)
  },

  async upsertMedicoGrupoOpme(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/medicos/${params.medicoId}/grupos-opme`, params)
    return factory.build(request)
  },

  async deleteGrupoOpmeDaSolicitacao({ solicitacaoId, grupoOpmeDaSolicitacaoId }: any) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}/grupos-opme/${grupoOpmeDaSolicitacaoId}`)
    return factory.build(request)
  },

  async getMedicoGradeDeHorario(params: any) {
    let query = ''
    if (params.inicio) query += `?inicio=${params.inicio}`
    if (params.fim) query += `&fim=${params.fim}`

    const request = await api.get(`medicos/${params.medicoId}/hospitais/${params.hospitalId}/grade-horarios${query}`)
    return factory.build(request)
  },

  async medicoInformaDataNaGradeDeHorarios(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/data-agendamento`, params)
    return factory.build(request)
  },

  async getAllCategoriasByConvenio({ hospitalId, convenioId }) {
    const request = await api.get(`hospitais/${hospitalId}/convenios/${convenioId}/categorias`)
    return factory.build(request)
  },

  async getCentroCirurgico(params: any) {
    const { hospitalIds } = params
    let query: string = ''
    if (hospitalIds && hospitalIds.length > 0) {
      hospitalIds.forEach((p: string) => {
        query += `&hospitalIds=${p}`
      })
    }
    const request = await api.get(`/hospital/centro-cirurgico?${query.substring(1, query.length)}`)
    return factory.build(request)
  },

  async deleteSolicitacao(solicitacaoId: string) {
    const request = await api.delete(`solicitacoes/${solicitacaoId}`)
    return factory.build(request)
  },

  async getAllCaixasCirurgicas() {
    const request = await api.get('caixa-cirurgica')
    return factory.build(request)
  },

  async getAllCaixasCirurgicasByHospitalId(params: any) {
    const request = await api.get(`hospitais/${params.hospitalId}/caixa-cirurgica?searchText=${params.searchText || ''}`)
    return factory.build(request)
  },

  async postCaixaCirurgicaToHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/caixa-cirurgica`, params)
    return factory.build(request)
  },

  async putCaixaCirurgicaToHospital(params: any) {
    const request = await api.put(`hospitais/${params.hospitalId}/caixa-cirurgica`, params)
    return factory.build(request)
  },

  async upsertCaixaCirurgicaBySolicitacaoId(params: any) {
    const request = await api.put(`solicitacoes/${params.solicitacaoId}/caixas-cirurgicas`, params)
    return factory.build(request)
  },

  async deleteCaixaCirurgicaBySolicitacaoId(params: any) {
    const request = await api.delete(`solicitacoes/${params.solicitacaoId}/caixas-cirurgicas/${params.id}`)
    return factory.build(request)
  },

  async getAllAnestesistas(params: any) {
    const { searchText, pagina, qtdPorPagina, hospitalId, tipo } = params
    const query: string = `searchText=${searchText || ''}&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 10}&hospitalId=${hospitalId}&tipo=${tipo || ''}`
    const request = await api.get(`/anestesistas?${query}`)
    return factory.build(request)
  },

  async getAnestesistaById(id: string) {
    const request = await api.get(`/anestesistas?id=${id}`)
    return factory.build(request)
  },

  async postAnestesista(params: any) {
    const request = await api.post('/anestesistas', params)
    return factory.build(request)
  },

  async adicionaPaciente(params: any) {
    const { paciente, hospitalId } = params
    const request = await api.post(`/hospital/${hospitalId}/adicionaPaciente`, paciente)
    return factory.build(request)
  },

  async putAnestesista(params: any) {
    const request = await api.put('/anestesistas', params)
    return factory.build(request)
  },

  async getAllAnestesistasByHospitalId(params: any) {
    const { hospitalId, searchText, pagina, qtdPorPagina } = params
    const query: string = `searchText=${searchText || ''}&pagina=${pagina || 1}&qtdPorPagina=${qtdPorPagina || 25}`
    const request = await api.get(`hospitais/${hospitalId}/anestesistas?${query}`)
    return factory.build(request)
  },

  async getAnestesistaByHospitalId(params: any) {
    const { hospitalId, id } = params
    const request = await api.get(`hospitais/${hospitalId}/anestesistas/${id}`)
    return factory.build(request)
  },

  async postAnestesistaToHospital(params: any) {
    const request = await api.post(`hospitais/${params.hospitalId}/anestesistas`, params)
    return factory.build(request)
  },

  async putAnestesistaToHospital(params: any) {
    const request = await api.put(`hospitais/${params.hospitalId}/anestesistas`, params)
    return factory.build(request)
  },

  async resolvePendenciaDeAnestesista(params: any) {
    const request = await api.put(`solicitacoes-backoffice/${params.solicitacaoId}/ResolvePendenciaAnestesista`, params)
    return factory.build(request)
  },

  async consultaCoberturaVigente(params: any) {
    const query = `?convenioId=${params.convenioId}&planoId=${params.planoId}&${params.tipo.toLowerCase()}Id=${params.id}`
    const request = await api.get(`hospitais/${params.hospitalId}/cobertura-vigente${query}`)
    return factory.build(request)
  },

  async updateCategoriaDoPlanoParaFidelizacao(solicitacaoId: string, categoriaDoPlanoParaFidelizacao: string) {
    const request = await api.put(`solicitacao/${solicitacaoId}/plano/categoria-do-plano-fidelizacao`, { categoriaDoPlanoParaFidelizacao })
    return factory.build(request)
  },

  async getProcedimentosHospitalDiaByHospital(params: any) {
    const searchParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]: any) => {
      if (key === 'hospitalId') return
      if (key === 'procedimentoIds' && Array.isArray(value)) {
        value.forEach((procedimentoId: string) => searchParams.append('procedimentoId', `${procedimentoId}`))
        return
      }
      value && searchParams.append(key, value)
    })

    const query = `?${searchParams.toString()}`

    const request = await api.get(`/hospitais/${params.hospitalId}/procedimentos/verifica-procedimento-hospital-dia${query}`)
    return factory.build(request)
  },

  async getAllOperadoras() {
    const request = await api.get('/operadoras')
    return factory.build(request)
  },

  async getAllTipoAcomodacao(hospitalId: string) {
    const request = await api.get(`/suporte/hospital/${hospitalId}/tipo-acomodacao/all`)
    return factory.build(request)
  },

  async gerarConfirmacaoCirurgica(solicitacaoId: string, tipo: 'Medico' | 'Paciente') {
    const request = await api.put(`/solicitacoes/${solicitacaoId}/confirmacao-de-cirurgia/gerar`, { tipo })
    return factory.build(request)
  },

  async confirmacaoCirurgicaConfirmarRecusar(solicitacaoId: string, tipo: 'Medico' | 'Paciente', status: ConfirmacaoCirurgicaStatusEnum) {
    const request = await api.put(`/solicitacoes/${solicitacaoId}/confirmacao-de-cirurgia`, { tipo, status })
    return factory.build(request)
  },

  async getHospitalTermsOfUse(hospitalId: string) {
    const request = await api.get(`/hospitais/${hospitalId}/termo-uso`)
    return factory.build(request)
  },

  async acceptHospitalTermsOfUse({ hospitalId, requestBody }) {
    const request = await api.post(`/hospital/${hospitalId}/aceita-termo-uso`, requestBody)
    return factory.build(request)
  },

  async getReservaGrade(hospitalId: string, medicoId: string, searchSchedulingPayload: SearchSchedulingPayloadProps) {
    const { Dia, ...rest } = searchSchedulingPayload
    const queryString = new URLSearchParams({ ...rest }).toString()
    const response = await api.get(`hospital/${hospitalId}/medico/${medicoId}/reserva-grade?${queryString}${Dia.map(item => `&Dia=${item}`).join('')}`)
    return factory.build(response)
  },

  async getSalaCirurgica(hospitalId: string, centroCirurgicoId: string) {
    const response = await api.get(`hospital/sala-cirurgica/tipo?HospitalId=${hospitalId}&CentroCirurgicoId=${centroCirurgicoId}`)
    return factory.build(response)
  },

  async getPaisAllWithHisId(hospitalId: string) {
    const request = await api.get(`hospital/${hospitalId}/paises`)
    return factory.build(request)
  },

  async sendSurgerySolicitationAuthorizationInfo({ surgerySolicitationId, requestBody }) {
    const request = await api.post(`/solicitacoes/${surgerySolicitationId}/MedicoEnviaSolicitacaoParaOAutorizador`, requestBody)
    return factory.build(request)
  },

  async getMotivoDeRecusaDoOrcamentoByHospitalId({ hospitalId, status }: { hospitalId: string, status: string | undefined }) {
    const query = status ? `?status=${status}` : ''
    const request = await api.get(`hospitais/${hospitalId}/motivos-recusa-orcamento${query}`)
    return factory.build(request)
  },

  async upsertMotivoDeRecusaDoOrcamento(motivoRecusaDoOrcamento: MotivoRecusaDoOrcamento) {
    const request = await api.put('hospitais/motivo-recusa-orcamento', motivoRecusaDoOrcamento)
    return factory.build(request)
  },

  async getSurgerySolicitationStatusesById(id: string) {
    const request = await api.get(`solicitacoes/status/${id}`)
    return factory.build<StatusOption[]>(request)
  },
}
